module.exports = __webpack_public_path__ + "static/media/hall-AF.f7fb75f3.svg";